<template>
<div>

 <v-container>
        <v-row>
          <v-col>
            <div class="home-title mt-4 card-title">The Welland Canal: First Canal   <v-btn text to="/TheWellandCanal">Go Back</v-btn> </div>
            
          </v-col>
        </v-row>
      </v-container>



    <v-container >
        <v-row>
            <v-col>

              <v-card>
                  <v-card-text class="body-1">
                      <h2>Operated 1829-1844</h2>
		40 Wooden Locks<br/>
		33.5 m (100 feet) long by 6.7 m (22 feet) wide<br/>
		2.4 m (8 feet) deep<br/>

			<p>
		In 1824, the Welland Canal Company began construction on the First Welland Canal. It opened between Lake Ontario and Chippawa on the Niagara River in 1829, with the section to Lake Erie opened in 1833. For William Hamilton Merritt, the businessman behind the canal, it was important the canal serve two purposes: providing shipping with a way to bypass Niagara Falls, and a regular supply of water for water-powered mills and other industries along the canal. Vessels and barges moved through the canal towed by teams of horses and mules. Built with 40 wooden locks that deteriorated rapidly, canal maintenance quickly became a problem, and the costs soon overwhelmed the Welland Canal Company. In 1841, the colonial government took over responsibility for the Welland Canal, and embarked on a plan to rebuild and improve the canal.
		</p>

                  </v-card-text>
              </v-card>
            </v-col>
             </v-row>
        <v-row>
            
        </v-row>
        <v-row> <v-col lg="4" sm="12">
                <v-card class="pt-4">
                    <v-img    src="../assets/images/Photo_1_First_Canal.jpg">
                  
                    </v-img>
                      
                    <image-viewer source="Photo_1_First_Canal.jpg"/>
                    <v-card-text class="body-1">
                        <h2>William Hamilton Merritt 1793-1862</h2>
		
			<p>
Much of the credit for building the first canal goes to an enterprising businessman, William Hamilton Merritt. He was a hard-working visionary who by 1818 owned a large house and a general store in St. Catharines, a farm and a mill site on Twelve Mile Creek. As more and more land was cleared for agriculture, millers like Merritt faced severe seasonal fluctuations in the water level of the creek, leading to periodic shortages of water to operate the mills. He devised a plan to tap the water of the Welland River (or as it was then known, Chippawa Creek) by digging a ditch to provide his mill with a constant supply of water. Since he could not afford the cost of this ditch, he decided to turn it into a canal, offering water transportation as well. He would then be able to form a company, issue stocks, and construct a canal to bypass Niagara Falls and connect Lake Ontario with Lake Erie. He convinced a number of potential investors of the feasibility of his plan, and a petition for incorporation was put before the colonial legislature by George Keefer, Thomas Merritt, George Adams, William Chisholm, Joseph Smith, Paul Shipman, John Decow, William Hamilton Merritt and others.  Legislation was passed on January 19, 1824 incorporating the Welland Canal Company.

		</p>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col lg="6">
               <v-container fluid>
                   <v-row wrap>
                       <v-col lg="6" sm="12">
                           <v-card>
                               <v-img width="500px" src="../assets/images/Report_1__First_Canal_Randall_recommends_Gravelly_Bay_1831.jpg"></v-img>
                              <image-viewer source="Report_1__First_Canal_Randall_recommends_Gravelly_Bay_1831.jpg"/>
                            <v-card-text class="body-1">
                                 A report by Robert Randall supporting Gravelly  Bay (the present-day harbour at Port Colborne) as the southern terminus of the Welland Canal.
 
                                </v-card-text>    
                           </v-card>
          
                       </v-col>
                       <v-col lg="6" sm="12">
                           <v-card>
                               <v-img  src="../assets/images/Map_3__First_Canal.jpg"></v-img>
                               <image-viewer source="Map_3__First_Canal.jpg"/>
                            <v-card-text class="body-1">
                               Map of the First Welland Canal route before 1833.
Map by Allan Pritchard from the publication The Welland Canal in story and picture.
                                </v-card-text>    
                           </v-card>
          
                       </v-col>
                         <v-col lg="6" sm="12">
                           <v-card>
                               <v-img  src="../assets/images/Map_2__First_Canal.jpg"></v-img>
                               <image-viewer source="Map_2__First_Canal.jpg"/>
                            <v-card-text class="body-1">
                              Historical map showing the Village of Port Colborne's buildings, the two proposed piers and the first Welland Canal with Lock 40 and the bridges crossing at the centre of the lock. This map was made by H.H. Killaly and was published in 1837, four years after the canal was completed.
Brock University Map, Data & GIS Library
                                </v-card-text>    
                           </v-card>
          
                       </v-col>
                        <v-col lg="6" sm="12">
                           <v-card>
                               <v-img  src="../assets/images/Map_4__First_Canal_Welland_Canal_1837_NMC_21589.jpg"></v-img>
                               <image-viewer source="Map_4__First_Canal_Welland_Canal_1837_NMC_21589.jpg"/>
                            <v-card-text class="body-1">
                            Historical Map of the Niagara District showing the various routes proposed for the Welland Canal, with a table of distances, by Sir Richard Henry Bonnycastle, 1837. 
Brock University Map, Data & GIS Library
                                </v-card-text>    
                           </v-card>
          
                       </v-col>
                       <v-col lg="6" sm="12">
                           <v-card>
                               <v-img  src="../assets/images/Image_1__First_Canal_985_5_208_inside_preview.jpg"></v-img>
                               <image-viewer source="Image_1__First_Canal_985_5_208_inside_preview.jpg"/>
                            <v-card-text class="body-1">                           Pastel drawing depicting the hand-operated wooden lock gates, and a schooner, its sails reefed for transit through the canal, towed by a horse through the First Welland Canal.
Published in “The Welland Ship Canal – New Link in the World’s Greatest Inland Waterway” (1932) Port Colborne Historical & Marine Museum 985.5.208

                                </v-card-text>    
                           </v-card>
          
                       </v-col>
                         <v-col lg="6" sm="12">
                           <v-card>
                               <v-img  src="../assets/images/Image_2__First_Canal_L_1_45_976_Linking_the_Great_Lakes.jpg"></v-img>
                               <image-viewer source="Image_2__First_Canal_L_1_45_976_Linking_the_Great_Lakes.jpg"/>
                            <v-card-text class="body-1">
                         The First Passage, November 27, 1829: This artist’s re-creation shows the Canadian vessel, Ann and Jane, at Lock 1 in Port Dalhousie, followed by the American vessel, B.H. Broughton, as they made the historic first transit of the Welland Canal, from Lake Ontario to Buffalo.
Port Colborne Historical & Marine Museum L.45.976
                                </v-card-text>    
                           </v-card>
          
                       </v-col>
                   </v-row>
               </v-container>
               
              </v-col>
        </v-row>
    </v-container>

</div>
</template>


<script>

export default {
  name: 'FirstCanal',
  components: {}
  
  ,
  data() {
    return {
     
    }
  },
}
</script>

<style>
   
</style>